import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { OtpChannel } from '../../../../services/strong-customer-authentication/model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BrandedRouter } from '../../../../services/brandedRouter';
import { WindowRef } from '../../../../services/windowRef';
import { AnalyticsService } from '../../../../services/analytics.service';
import { GTMTracking } from '../../../../enums/google-analytics-tracking';

@Component({
  selector: 'select-otp-channel-form',
  templateUrl: 'select-otp-channel-form.component.html',
})
export class SelectOtpChannelFormComponent implements OnInit {
  @Input()
  public isSubmitting: boolean;
  @Input()
  public mobileNumber: string;
  @Input()
  public homeNumber: string;
  @Input()
  formName: string;
  @Output()
  onValid = new EventEmitter();

  public notMyNumberDropdownOpen: boolean;
  public form: FormGroup;
  public authCodePreference: FormControl;
  public OtpChannel = OtpChannel;
  public contactUsLink: string;

  constructor(
    private brandedRouter: BrandedRouter,
    private windowRef: WindowRef,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.notMyNumberDropdownOpen = false;
    this.contactUsLink = this.brandedRouter.getBrandedLink('/help/contact-us');
    this.createForm();
  }

  createForm() {
    this.authCodePreference = new FormControl('', [Validators.required]);
    this.form = new FormGroup({
      authCodePreference: this.authCodePreference,
    });
    this.authCodePreference.setValue(
      this.mobileNumber ? OtpChannel.Text : OtpChannel.Call
    );
    this.windowRef.setFocusById('authcode-by-text');
  }

  getSelectedOtpChannel(): OtpChannel {
    if (!this.authCodePreference) {
      return OtpChannel.Text;
    }
    return this.authCodePreference.value || OtpChannel.Text;
  }

  otpTracking(e: Event, trackingName: string) {
    e.preventDefault();
    if (this.formName === 'register') {
      this.analyticsService.trackCtaActions(GTMTracking[trackingName]);
    }
  }

  public onSubmit() {
    this.onValid.emit(this.authCodePreference.value);
    if (this.formName === 'register') {
      this.authCodePreference.value === 0
        ? this.analyticsService.trackCtaActions(GTMTracking.OtpText)
        : this.analyticsService.trackCtaActions(GTMTracking.OtpCall);
    }
  }
}
